module.exports = __webpack_public_path__ + "img/6.1cc73b2c.jpg";